import locale from "@/helpers/locale";
import moment from "moment";

export const thead = () => {
  return [
    {
      label: locale("accountingReportDownload.th.theaterName"),
      prop: "cinemaName",
      align: "center"
    },
    {
      label: locale("accountingReportDownload.th.month"),
      prop: "month",
      align: "center",
    },
    {
      label: locale("accountingReportDownload.th.accountName"),
      prop: "createAccountName",
      align: "center"
    },
    {
      label: locale("accountingReportDownload.th.createDateTime"),
      prop: "createTime",
      align: "center",
    }
  ];
};

export const formatData = (originalArr => {
  let newArr = [], notApprove = false;
  originalArr.map(item => {
    let obj = {};

    obj.id = item.id;
    obj.cinemaBrandName = item.cinemaBrandName;
    obj.month = moment(item.monthString).format("YYYY/MM");
    obj.operationName = item.operationName;
    obj.createTime = moment(item.createTime).format("YYYY/MM/DD HH:mm:ss");
    obj.approve = item.approve;

    newArr.push(obj);
  });

  notApprove = originalArr.some(item => item.approve === false);

  return {
    notApprove: notApprove,
    tableData: newArr,
  };
});